module.exports = __webpack_public_path__ + "img/design.f7c3b62a.svg";